namespace Matrix.Workflow {
    export interface WorkflowMapRow {
        MapId?: number;
        TestCode?: string;
        ResultCode?: string;
        FailThreshold?: number;
        WorkflowCode?: string;
        HelpText?: string;
        CustomFilter?: string;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
        TestDescription?: string;
        TestRowId?: number;
        WorkflowDescription?: string;
        WorkflowRowId?: number;
    }

    export namespace WorkflowMapRow {
        export const idProperty = 'MapId';
        export const nameProperty = 'TestCode';
        export const localTextPrefix = 'Workflow.WorkflowMap';
        export const deletePermission = 'DataAdmin:WorkflowMap';
        export const insertPermission = 'DataAdmin:WorkflowMap';
        export const readPermission = 'Read:WorkflowMap';
        export const updatePermission = 'DataAdmin:WorkflowMap';

        export declare const enum Fields {
            MapId = "MapId",
            TestCode = "TestCode",
            ResultCode = "ResultCode",
            FailThreshold = "FailThreshold",
            WorkflowCode = "WorkflowCode",
            HelpText = "HelpText",
            CustomFilter = "CustomFilter",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen",
            TestDescription = "TestDescription",
            TestRowId = "TestRowId",
            WorkflowDescription = "WorkflowDescription",
            WorkflowRowId = "WorkflowRowId"
        }
    }
}
